import { StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * CategoryPointTooltip: this tooltip contains category and point info.
 */
export class CategoryPointTooltip {
	public static getFormatter(): Function {
		return function (): string {
			if (this.point.tooltip) {
				return this.point.tooltip;
			}
			return '<b>' + StringUtil.escapeHtml(this.point.category) + '</b> ' + Highcharts.numberFormat(this.point.y, 2, '.', ',') + '%';
		};
	}
}
